import { get } from 'lodash-es';
import { getApiEndpoint } from 'srcAlias/utils/url';
import { createHeaders } from 'srcAlias/utils/headers';
import config from 'configAlias';
import { fetch } from '@atlas/fetch';

export const callSessionTimeout = async (
  refreshSession,
  setIsLoading,
  sessionId
) => {
  const appConfig = get(config, 'appConfig', {});

  const headersDetails = {
    applicationType: get(appConfig, 'applicationType'),
    channelId: get(appConfig, 'channelId'),
    sessionId: sessionId,
    countryCode: get(appConfig, 'countryCode'),
    groupMember: get(appConfig, 'groupMember'),
  };

  const baseUrl = getApiEndpoint();
  const timeoutOptions = {
    min: get(appConfig, 'apiCallTimeOut.sessionTimeoutCall.customerMinTimeout'),
    max: get(appConfig, 'apiCallTimeOut.sessionTimeoutCall.customerMaxTimeout'),
    clientOverallMax: get(
      appConfig,
      'apiCallTimeOut.sessionTimeoutCall.clientOverallMaxTimeout'
    ),
  };

  //call application-data-review to refresh session
  const apiEndpoint =
    process.env.REACT_APP_CREATE_MOCK_SERVER === 'true'
      ? 'api/v0/application-data-review'
      : process.env.REACT_APP_APP_DATA_REVIEW_URL;
  const finalUrl = `${baseUrl}/${apiEndpoint}`;
  const sessiontimeoutResponse = await fetch(
    finalUrl,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        ...createHeaders(headersDetails),
      },
    },
    timeoutOptions
  );

  return get(sessiontimeoutResponse, 'status');
};

export default callSessionTimeout;
